import { Box, Button, Stack, Typography } from '@mui/material';
import { AppBar } from 'components/AppBar/AppBar';
import { Row } from 'components/Row/Row';
import React from 'react';
import { Link } from 'react-router-dom';
import { ToggleSwitch } from '../ToggleSwitch/ToggleSwitch';
import { BenefitCard } from './BenefitCard';

export function Pricing() {
  const [showCreatorAnnual, setShowCreatorAnnual] = React.useState(false);
  const [showLearnerAnnual, setShowLearnerAnnual] = React.useState(false);

  const annualLabel = (
    <>
      Annual
      <Typography variant='bodySmall' color='textSecondary'>
        Save up to 27%
      </Typography>
    </>
  );

  return (
    <Box sx={{ bgcolor: 'surface.main' }}>
      <AppBar sx={{ bgcolor: 'surface.main' }} />

      <Stack
        gap={6}
        alignItems='center'
        py={10}
        sx={{ background: `radial-gradient(circle 80vh at center bottom, #F1ECF4FF, transparent)` }}
      >
        <Stack gap={2} alignItems='center'>
          <Typography variant='displayMedium'>
            Kyron
            <Typography variant='inherit' color='primary.main' component='span'>
              &nbsp;Creator Studio&nbsp;
            </Typography>
            Pricing
          </Typography>
          <Typography variant='bodyLarge' color='text.secondary'>
            Create and assign AI-powered interactive lessons.
          </Typography>
        </Stack>

        <ToggleSwitch
          offLabel='Monthly'
          onLabel={annualLabel}
          handleOff={() => setShowCreatorAnnual(false)}
          handleOn={() => setShowCreatorAnnual(true)}
        />

        <Row gap={4} sx={{ alignItems: 'stretch' }}>
          <BenefitCard
            label='Basic'
            price={0}
            benefits={[
              'Create unlimited public interactive lessons',
              'AI-assisted lesson creation',
              'Manage your own content channel',
            ]}
          />

          <BenefitCard
            label='Educator'
            price={showCreatorAnnual ? 8.33 : 9.99}
            priceDetails={<>per user/month {showCreatorAnnual && <div>billed annually</div>}</>}
            benefits={[
              'Create unlimited public or private interactive lessons',
              'AI-assisted lesson creation',
              'Collaborate with colleagues',
              'Assign lessons to under 1000 learners',
              'Integrate with Google Classroom or any other LTI-enabled LMS',
              'Learner progress dashboards and insights',
              'K12 discounts available!',
            ]}
          />

          <BenefitCard
            label='Premium'
            price={showCreatorAnnual ? 7.5 : 8.99}
            priceDetails={<>per user/month {showCreatorAnnual && <div>billed annually</div>}</>}
            benefits={[
              'Create unlimited public or private interactive lessons',
              'AI-assisted lesson creation',
              'Collaborate with colleagues',
              'Assign lessons to over 1000 learners',
              'Integrate with Google Classroom or any other LTI-enabled LMS',
              'Learner progress dashboards and insights',
              'K12 discounts available!',
            ]}
          />
        </Row>

        <Stack alignItems='center' gap={2}>
          <Stack alignItems='center'>
            <Typography variant='bodyLarge' color='text.secondary'>
              Do you have over 10,000 learners?
            </Typography>
            <Typography variant='bodyLarge' color='text.secondary'>
              Interested in discussing usage-based pricing?
            </Typography>
          </Stack>
          <Button component={Link} to='mailto:sales@kyronlearning.com'>
            Contact sales to learn more
          </Button>
        </Stack>
      </Stack>

      <Stack
        gap={6}
        alignItems='center'
        paddingTop={10}
        paddingBottom={14}
        sx={{ background: 'radial-gradient(circle 80vh at center top, transparent, #F1ECF4FF)' }}
      >
        <Stack gap={2} alignItems='center'>
          <Typography variant='displayMedium'>
            Kyron
            <Typography variant='inherit' color='primary' component='span'>
              &nbsp;Learner&nbsp;
            </Typography>
            Membership
          </Typography>
          <Typography variant='bodyLarge'>Learn from the world&apos;s best teachers with an AI-assist.</Typography>
        </Stack>

        <ToggleSwitch
          offLabel='Monthly'
          onLabel={annualLabel}
          handleOff={() => setShowLearnerAnnual(false)}
          handleOn={() => setShowLearnerAnnual(true)}
        />

        <Row gap={4} sx={{ alignItems: 'stretch' }}>
          <BenefitCard
            price={showLearnerAnnual ? 8.33 : 9.99}
            priceDetails={<>per month {showLearnerAnnual && <div>billed annually</div>}</>}
            benefits={[
              'Take up to 3 public lessons per month',
              'AI-powered interactive lessons',
              'Lessons on a variety of topics',
              'Save lessons to watch later',
            ]}
            sx={{ width: '440px' }}
          />
        </Row>
      </Stack>
    </Box>
  );
}
